module.exports = __webpack_public_path__ + "static/media/content-step1.b4ef043c.jpg";